import * as React from 'react';

const TealiumContext = /*#__PURE__*/ React.createContext({});
TealiumContext.displayName = 'TealiumContext';
const useTealium = ()=>React.useContext(TealiumContext)
;

export { useTealium };
//# sourceMappingURL=provider.js.map
